module.exports = __webpack_public_path__ + "static/media/residencial.c2ed34f8.jpg";